import React from "react";

interface ErrorCenteredProps {}

export const ErrorCentered: React.FC<ErrorCenteredProps> = () => {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <h2>Įvyko klaida</h2>
    </div>
  );
};
